import { Fragment, ReactNode, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";

import { applicationConfig } from "../../../../environmentConfiguration";
import { RouteConstants } from "../../../models/enums";
import { Device } from "../../../stores";
import { useStore } from "../../../stores/StoreContext";
import { CompanyLogo } from "../../Core/NavbarElements/CompanyLogo/CompanyLogo";
import { CurrentUserBudgetInfo } from "../../Core/NavbarElements/CurrentUserBudgetInfo/CurrentUserBudgetInfo";
import { FeatureSelection } from "../../Core/NavbarElements/FeatureSelection/FeatureSelection";
import { LanguageSelection } from "../../Core/NavbarElements/LanguageSelection/LanguageSelection";
import { NavbarDivider } from "../../Core/NavbarElements/NavbarDivider/NavbarDivider";
import { UserProfile } from "../../Core/NavbarElements/UserProfile/UserProfile";

import "./Navbar.scss";

interface INavbarElement {
  id: string;
  element: ReactNode;
  hide?: boolean;
}

const NavbarComponentRaw = () => {
  const { userStore, navigationStore, breakpointStore } = useStore();

  const [navbarElements, setNavbarElements] = useState<INavbarElement[]>([]);

  useEffect(() => {
    const navbarElements: INavbarElement[] = [
      { id: "budget-info", element: <CurrentUserBudgetInfo /> },
      {
        id: "feature-selection",
        element: <FeatureSelection />,
        hide:
          (applicationConfig.featureFlags.enableTermsOfUse && !userStore.userAcceptedTermsOfUseAndPrivacyPolicy) ||
          navigationStore.currentActiveMenuItem?.path === RouteConstants.LandingPage ||
          breakpointStore.isSmallerThan(Device.Tablet),
        // Do not render the feature selection if terms of use are not accepted and feature flag is enabled
      },
      { id: "language-selection", element: <LanguageSelection /> },
    ];

    const filteredNavbarElements = navbarElements.filter(navbarElement => !navbarElement.hide);

    setNavbarElements(filteredNavbarElements);
  }, [
    userStore.userAcceptedTermsOfUseAndPrivacyPolicy,
    userStore.currentLanguage,
    navigationStore.currentActiveMenuItem,
    breakpointStore.device,
  ]);

  return (
    <div className="navbar">
      <div className="left-area">
        <CompanyLogo />
      </div>

      <div className="right-area">
        {navbarElements.map(
          (navbarElement, index) =>
            !navbarElement.hide && (
              <Fragment key={navbarElement.id}>
                {navbarElement.element}
                {index < navbarElements.length - 1 && <NavbarDivider />}
              </Fragment>
            ),
        )}

        <UserProfile />
      </div>
    </div>
  );
};

export const NavbarComponent = observer(NavbarComponentRaw);
